// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"588":"8f5b7e82162c8719","726":"23314bc5512abc02"}[chunkId] + ".js";
};